module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.71e8fd8e.ttf";